import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import * as MediaUpload from './MediaUpload';

export type V_Active = {
  '@id': string;
  '@type': 'ChatConversation';
  user: {
    '@id': string;
    '@type': 'User';
    name: string | null;
    displayPicture: MediaUpload.BaseView | null;
  } | null;
  conversation: {
    '@id': string;
    '@type': 'ChatConversation';
    id: string;
    lastMessage: {
      '@id': string;
      '@type': 'ChatMessage';
      message: string | null;
      media: Array<MediaUpload.BaseView>;
      createdAt: string;
    } | null;
    clinicianLastReadAt: string | null;
  } | null;
};

export type V_Archived = {
  '@id': string;
  '@type': 'ChatConversation';
  user: {
    '@id': string;
    '@type': 'User';
    name: string | null;
    displayPicture: MediaUpload.BaseView | null;
  } | null;
  conversation: {
    '@id': string;
    '@type': 'ChatConversation';
    id: string;
    lastMessage: {
      '@id': string;
      '@type': 'ChatMessage';
      message: string | null;
      media: Array<MediaUpload.BaseView>;
      createdAt: string;
    } | null;
    clinicianLastReadAt: string | null;
  } | null;
};

export type V_Broadcast = {
  '@id': string;
  '@type': 'ChatConversation';
  user: {
    '@id': string;
    '@type': 'User';
    name: string | null;
    displayPicture: MediaUpload.BaseView | null;
  } | null;
  team: {
    '@id': string;
    '@type': 'OrganisationTeam';
    name: string;
    organisation: {
      '@id': string;
      '@type': 'Organisation';
      name: string;
    };
  } | null;
  teamMembers: Array<{
    '@id': string;
    '@type': 'User';
    name: string | null;
    displayPicture: MediaUpload.BaseView | null;
  }>;
  conversation: {
    '@id': string;
    '@type': 'ChatConversation';
    id: string;
    lastMessage: {
      '@id': string;
      '@type': 'ChatMessage';
      message: string | null;
      media: Array<MediaUpload.BaseView>;
      createdAt: string;
    } | null;
    clinicianLastReadAt: string | null;
  } | null;
};

export function useReadCollectionClinicianactive(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_Active>>(
    `/chat-conversations/clinician/active`,
    options,
  );
}

export function useReadCollectionClinicianarchived(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_Archived>>(
    `/chat-conversations/clinician/archived`,
    options,
  );
}

export function useReadCollectionClinicianbroadcast(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_Broadcast>>(
    `/chat-conversations/clinician/broadcast`,
    options,
  );
}
